// extracted by mini-css-extract-plugin
export default {"generationFinishPage":"GenerationFinishPage_generationFinishPage__nRs07","container":"GenerationFinishPage_container__Ilyj+"};